import {Speaker} from "mapping/speaker";
import {generateFullUrl} from "services/utils/utils";
import {Video} from "mapping/video";

export const Event = {
    fromServer: (data) => {
        const event = data.event;
        const userStats = data.user_stats;
        const link = data.link || {};
        return {
            id: event.id,
            categories: data.categories,
            tags: data.tags,
            requires_payment: event.cost !== "0.00",
            cost: event.cost,
            favorite: userStats.favorite,
            title: event.title,
            image: generateFullUrl(event.image),
            start_date: event.start_at,
            end_date: event.end_at,
            type: event.is_online ? "online" : "live",
            category: event.type,
            place: event.place,
            tickets_available: event.seats,
            unlimited_tickets: event.has_unlimited_seats,
            description: event.description,
            speakers: data.speakers.map(Speaker.fromServer),
            likes: {
                total: data.likes,
                avatars: data.lastLikesAvatars.map(generateFullUrl)
            },
            like: userStats.liked,
            link: {
                label: link.label,
                link: link.link
            },
            material: event.attachments,
            videos: (data.videos || []).map(Video.fromServer)
        }
    },
    toServer: (data) => {
        return {
            ...data
        }
    }
}